<template>

   <div class="d-row d-flex align-items-center">
      <div class="col-4">
         <input v-model.trim="search" type="text" class="form-control form-control-sm"
            placeholder="🔍 Search activity timeline...."
            style="border-radius:40px;font-size: 14px; font-family: 'Roboto', sans-serif;"
            @keyup="onSearch()" />
      </div>

      <!-- <vue-date-picker ref="datePickerRef" v-model="audit.completionDate" input-class-name="date-picker-input"
         auto-apply :enable-time-picker="false" position="left" placeholder="" format="dd-MMM-yyyy" :teleport="true"
         :min-date="new Date()" :disabled="audit.isCompleted" /> -->
      <!-- FILTERS -->
      <div class="col-8 d-flex flex-row justify-content-end">
         <div class="dropdown d-flex flex-row align-items-center">
            <button type="button" class="fw-bold btn btn-outline-info btn-sm me-4"
               style="width:100%; max-width: 150px; border-radius: 10px!important;" @click="toggleFilterForm()"
               data-bs-toggle="dropdown" ref="filterButtonRef">
               <i class="filter-icon fa-solid fa-filter"></i>
               <span class="filter-text"> Filter </span>
            </button>

            <div id="filterForm" class="dropdown-menu pe-0 pt-1" style="min-width: 250px;">
               <div class="p-2 d-flex flex-row align-items-center justify-content-between">
                  <select v-model="filterBy" class="form-select shadow-none" style="width:150px;">
                     <option v-for="filter in filterByList" :value="filter.value" :key="filter.value">{{
                        filter.text }}
                     </option>
                  </select>

                  <button type="button" class="btn btn-warning text-light btn-sm ms-2 small" style="width: 80px"
                     @click="$event.stopPropagation(); clearFilter()">Clear filter</button>
               </div>

               <div class="p-2 d-flex flex-row align-items-center">
                  <select v-if="filterBy == 'user'" v-model="filterByUser" class="form-select shadow-none"
                     style="width:100%">
                     <!-- <option selected disabled value>Select {{ filterBy }}...</option> -->
                     <option v-for="option in filterValueOptions" :value="option.id" :key="option.id">{{
                        option.name }}
                     </option>
                  </select>

                  <select v-if="filterBy == 'activity'" v-model="filterByActivity" class="form-select shadow-none"
                     style="width:100%">
                     <!-- <option selected disabled value>Select {{ filterBy }}...</option> -->
                     <option v-for="option in filterValueOptions" :value="option.id" :key="option.id">{{
                        option.name }}
                     </option>
                  </select>
               </div>
            </div>
         </div>

         <!-- <div class="d-flex flex-row align-items-center">
            <span class="p-2 filterTitle">Activity Filter:</span>
            <select v-model="filterByStatus" class="form-select shadow-none filterOptions"
               style="width:auto;border:none">
               <option value="none" selected>All</option>
               <option v-for="activity in activities" :key="activity.id" :value="activity.id">{{
                  activity.display_name }}</option>
            </select>
         </div>
         &nbsp; -->
         <div class="d-flex flex-row align-items-start">
            <span class="p-2 filterTitle">Date:</span>
            <!-- <input type="date" class="form-control pointer-change" id="date" :min="today" max="2100-12-31"
               v-model="filterByDate" /> -->
            <datepicker auto-apply :enable-time-picker="false" position="left" placeholder="" format="dd-MMM-yyyy"
               :teleport="true" input-class-name="date-picker-input" v-model="filterByDate" range>
            </datepicker>
         </div>
      </div>
      <!-- END FILTERS -->
   </div>

   <br><br>

   <form class="row g-0" style="gap: 0.5rem">

      <div class="form-floating">
         <textarea ref="addNoteRef" class="form-control add-note-textarea" id="enquiryDetails"
            v-model.trim="enquiryDetails" placeholder="Write additional notes..."
            oninput="this.style.height = this.scrollHeight + 2 + 'px'"></textarea>
         <label for="enquiryDetails" class="text-muted">Write additional update/notes...</label>
      </div>

      <div class="mb-3 text-end">
         <button type="button" class="btn btn-warning text-light" @click="createLeadNote(lead.id)"
            :disabled="disableAddNoteButton()"> New Update </button>
      </div>
   </form>

   <Timeline ref="timelineRef" :timeline-items="dataTimeline" :message-when-no-items="messageWhenNoItems"
      style="white-space: pre-wrap;">

      <template #section-button="{ data }">
         <div class="section-button" v-if="showEditButton(data)">
            <button title="Click to edit" class="btn btn-circle btn-circle-info" @click="isEdit(data)">
               <i class="fa fa-pen"></i>
            </button>
         </div>
      </template>

      <template #activity="{ data }">
         <p class="activity-title" :title="`Note Type: ` + data.note_type">{{ data.activity_title }}
            <!-- <small v-if="data.note_type.includes('initial_note_pentest')" style="font-weight:400;font-style:italic;">(see Penetration Test tab for more details)</small> -->
         </p>

         <div v-if="editingData != data.id">

            <div v-if="data.note_type == 'status_change' || data.note_type == 'status' || data.note_type == 'priority' || data.note_type == 'specific_status' || (data.note_type == 'cold_lead' && verifyColdLeadLength(data.activity_details))">
               <span v-if="data.note_type == 'status_change' || data.note_type == 'status'" class="pe-2 prevStatus">{{ formatStatusDisplay(statusChange(data.activity_details)[0])
                  }}</span>
               <span v-if="data.note_type == 'priority' || data.note_type == 'specific_status'" class="pe-2"
                  :class="statusChange(data.activity_details)[0].toLowerCase()">{{
                     formatStatusDisplay(statusChange(data.activity_details)[0]) }}</span>
               <span v-if="data.note_type == 'cold_lead'" class="pe-2"
                  :class="statusChange(data.activity_details)[0].toLowerCase()">{{
                     formatStatusDisplay(statusChange(data.activity_details)[0]) }}</span>

               <span class="pe-2"><i class="fa fa-arrow-right"></i></span>

               <span v-if="data.note_type == 'status_change' || data.note_type == 'status'" class="pe-2 newStatus">{{ formatStatusDisplay(statusChange(data.activity_details)[1])
                  }}</span>
               <span v-if="data.note_type == 'priority' || data.note_type == 'specific_status'" class="pe-2"
                  :class="statusChange(data.activity_details)[1].toLowerCase()">{{
                     formatStatusDisplay(statusChange(data.activity_details)[1]) }}</span>
               <span v-if="data.note_type == 'cold_lead'" class="pe-2"
                  :class="statusChange(data.activity_details)[1].toLowerCase()">{{
                     formatStatusDisplay(statusChange(data.activity_details)[1]) }}</span>
            </div>

            <div v-else-if="data.note_type == 'auth_org_link' || data.note_type == 'auth_sync'">
               <span v-if="!data.activity_details.includes('-')" class="auth_org_link_details">{{ data.activity_details
                  }}</span>

               <span v-else>
                  <span>{{ authOrgChange(data.activity_details)[0] + " - " }}</span>
                  <span style="font-weight:900">{{ authOrgChange(data.activity_details)[1] }}</span>
               </span>
            </div>

            <div v-else>
               <span class="activity-details">{{ data.activity_details }}</span>
            </div>
         </div>

         <div v-if="isEditing && editingData == data.id">
            <textarea ref="editNoteRef" class="form-control activity-textarea" id="editNote"
               v-model.trim="data.note_details"></textarea>

            <div class="d-row d-flex pt-2 justify-content-end" style="gap: 0.5rem">
               <button type="button" class="btn btn-outline-warning" title="Click to cancel"
                  @click="cancelEdit(data)">Cancel</button>
               <button type="button" class="btn btn-outline-info" title="Click to save" @click="updateLeadNote(data)"
                  :disabled="disableEditNoteButton(data.note_details)">Save</button>
            </div>
         </div>
      </template>
   </Timeline>


</template>

<script>
import moment from "moment";
import { toTitleCase } from '@/plugins/helper.js'
import Timeline from '@/components/Timeline/Timeline.vue'
import { debounce } from '@/plugins/helper.js'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import '@/assets/css/vue-datetimepicker.css'
//import DatePicker from 'vue3-datepicker';

export default {

   components: {
      Timeline,
      //VueDatePicker,
      Datepicker
   },

   data() {
      return {
         lead: {
            id: '',
            organisation: '',
         },
         search: "",
         leadNotes: [],
         leadNote: {
            id: '',
            noteType: '',
            noteDetails: '',
            lead: '',
            createdBy: '',
         },
         enquiryDetails: '',
         currentDate: null,
         isEditing: false,
         editingData: '',
         debounceFn: null,
         messageWhenNoItems: 'There are no items',
         activities: [
            {
               id: "initial_status",
               display_name: "Enquiry Details"
            }
         ],
         filterBy: "",
         filterByActivity: "none",
         filterByUser: "none",
         filterByDate: null,
         filterByList: [
            { text: "None", value: "" },
            { text: "User", value: "user" },
            { text: "Activity", value: "activity" },
         ],
         filterValueOptions: [],
         filtering: {
            field: "",
            value: ""
         },
         dateRange: null,
         vtxUsers: [],
      }

   },

   created() {
      this.getVertexUsers()
   },

   computed: {

      dataTimeline() {
         if (this.leadNotes.length > 0) {

            this.leadNotes.forEach((note) => {

               note.activity_details = note.note_details

               if (note.note_type.includes("initial_status")) {
                  note.activity_title = "Lead Created"
                  note.activity_details = "Created lead for " + this.lead.organisation

                  if (note.note_type.includes("website")) {
                     note.activity_title += " from Website"
                  } else if (note.note_type.includes("pentest")) {
                     note.activity_title += " from PenTest Form"
                  } else if (note.note_type.includes("internal")) {
                     note.activity_title += " from Internal Form"
                  }
               } else if (note.note_type.includes("initial_note")) {
                  note.activity_title = "Enquiry Details"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("specific_status")) {
                  note.activity_title = "Priority Update"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("status")) {
                  note.activity_title = "Status Update"
                  // note.activity_details = this.statusChange(note.note_details)
               } else if (note.note_type.includes("priority")) {
                  note.activity_title = "Priority Update"
                  // note.activity_details = this.statusChange(note.note_details)
               } else if (note.note_type.includes("auth_org_link")) {
                  note.activity_title = "Auth Organisation Link Update"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("auth_sync")) {
                  note.activity_title = "Auth Organisation Sync"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("loss_reason")) {
                  note.activity_title = "Lost Reason"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("proposal_upload")) {
                  note.activity_title = "Proposal Upload"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("cold_lead")) {
                  note.activity_title = "Cold Lead Priority Change"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("proposal_revision")) {
                  note.activity_title = "Proposal Revision"
                  // note.activity_details = note.note_details
               } else if (note.note_type.includes("contract_sent")) {
                  note.activity_title = "Contract Sent"
                  // note.activity_details = note.note_details
               } else {
                  note.activity_title = "Additional Update"
                  // note.activity_details = note.note_details
               }

            })

         }

         return this.leadNotes
      },

      filterByField() {
         return this.filterBy
      },
   },

   watch: {

      filterByUser() {
         this.debounceFn(this.lead.id)
      },

      filterByActivity() {
         this.debounceFn(this.lead.id)
      },

      filterByDate() {
         // if (this.filterByDate != null)
         this.debounceFn(this.lead.id)
      },

      filterByField() {
         this.setFilterOptions(this.filterBy)
         this.filtering.field = this.filterBy
         if (this.filterBy == "user") {
            this.filterByUser = "none"
            this.filterByActivity = "none"
         } else if (this.filterBy == "activity") {
            this.filterByActivity = "none"
            this.filterByUser = "none"
         }
      },

   },

   methods: {
      init(id) {
         this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         this.getVertexUsers()
         this.getLead(id)
         this.getLeadNotes(id)
         this.debounceFn = debounce((notes_id) => this.getLeadNotes(notes_id), 500)
      },

      formatDate(date, type) {
         if (type == "full") {
            return moment(date).format("DD-MMM-YYYY h:mm A")
         } else {
            return moment(date).format("DD-MMM-YYYY")
         }

      },

      formatUtcToTimeZone(utcDateString) {
         // 1. Parse the UTC date string into a Date object.
         // JavaScript Date objects internally represent time as milliseconds since the Unix epoch,
         // which is timezone-agnostic (effectively UTC).
         const date = new Date(utcDateString);

         // 2. Define formatting options.
         // 'timeZone' option tells Intl.DateTimeFormat to convert the date to this specific time zone.
         const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false, // Use 24-hour format
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            // Optional: timeZoneName: 'short' or 'long' if you want to include the time zone name
         };

         // 3. Create an Intl.DateTimeFormat instance and format the date.
         return new Intl.DateTimeFormat('en-US', options).format(date);
      },

      formatToTitleCase(str) {
         return toTitleCase(str)
      },

      resetForm() {
         this.leadNote.noteDetails = ''
         this.enquiryDetails = ''
         this.isEditing = false
         this.editingData = ''


         // set height of edit note text area to fit content
         this.$nextTick(() => {
            const textarea = this.$refs.addNoteRef
            textarea.style.height = '80px';
         });
      },

      disableAddNoteButton() {
         return this.enquiryDetails.trim() == ""
      },

      showEditButton(data) {

         if (data.note_type == 'note' || data.note_type == 'loss_reason') {
            // get duration from date created to today
            let currentDate = moment(new Date(), "DD/MM/YYYY")
            let noteDateCreated = moment(new Date(data.date_created), "DD/MM/YYYY")

            let duration = currentDate.diff(noteDateCreated, 'days') + 1;

            // disable editing if commentor is not the user logged in and
            // if comment has exceeded 7 days from creation date
            if (this.$store.state.auth.jwtPayload.user_id == data.created_by &&
               duration <= 7) {
               return true
            }

            return false
         }

         return false
      },

      preventKeyPress: function (evt) {
         evt = (evt) ? evt : window.event;
         evt.preventDefault();
      },

      isEdit(data) {
         this.isEditing = true
         this.editingData = data.id
         this.getLeadNote(data.lead_id, data.id)

         // Keep track of the original data
         this._beforeEditingCache = Object.assign({}, data);

         // set height of edit note text area to fit content
         this.$nextTick(() => {
            const textarea = this.$refs.editNoteRef
            textarea.style.height = textarea.scrollHeight + 2 + 'px';
         });

      },

      cancelEdit(data) {
         // Return the data back to it’s previous state
         Object.assign(data, this._beforeEditingCache);

         this.resetForm()
         this._beforeEditingCache = ''

      },

      //disable save button when no changes have been made
      disableEditNoteButton(updatedNote) {
         return updatedNote == this._beforeEditingCache.note_details
      },

       formatStatusDisplay(str) {
          if (!str) return ''
          // Replace underscores with spaces
          let formatted = str.replace(/_/g, ' ')
          // Add a space before a capital letter, but not at the start of the string
          formatted = formatted.replace(/([A-Z])/g, ' $1').trim()
          // Capitalize each word (Title Case)
          return formatted.replace(/\w\S*/g, function (txt) {
             return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          });
       },

      statusChange(value) {
         let str = value
         let statusChange = str.split(",").map(item => item.trim())
         return statusChange
      },

      verifyColdLeadLength(value) {
         let str = value
         let statusChange = str.split(",").map(item => item.trim())
         return statusChange.length >= 2
      },

      authOrgChange(value) {
         let str = value

         if (str.includes(" - ")) {
            str = str.split(" - ").map(item => item.trim())
         }

         return str
      },

      async getLead(id) {

         await this.$axios.get("/leads/" + id)
            .then((response) => {
               this.lead.id = response.data.lead.id
               this.lead.organisation = response.data.lead.organisation_name
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })

      },

      async getLeadNote(leadId, noteId) {

         await this.$axios.get("/leads/" + leadId + "/notes/" + noteId)
            .then((response) => {

               this.leadNote.id = response.data.note.id
               this.leadNote.noteType = response.data.note.note_type
               this.leadNote.noteDetails = response.data.note.note_details
               this.leadNote.lead = response.data.note.lead_id
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })

      },

      async getLeadNotes(id) {
         let apiPath = "/leads/" + id + "/notes?"

         if (this.search != "") {
            apiPath += "search=" + this.search
         }

         if (this.filterByActivity != "" && this.filterByActivity != "none") {
            apiPath += "&activity=" + this.filterByActivity
         }

         if (this.filterByUser != "" && this.filterByUser != "none") {
            apiPath += "&user=" + this.filterByUser
         }


         //console.log(this.filterByDate)
         if (this.filterByDate != null) {
            this.filterByDate[0] = this.convertToUTC(this.filterByDate[0])
            this.filterByDate[1] = this.convertToUTC(this.filterByDate[1])
            let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
            apiPath += "&search_date_from=" + this.filterByDate[0] + "&search_date_to=" + this.filterByDate[1] + "&search_tz=" + tz
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               this.leadNotes = response.data.items
               this.getUser()

            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      convertToUTC(timestampWithTimezone) {
         const date = new Date(timestampWithTimezone);
         // Get the ISO string (e.g., "2025-05-27T14:22:36.000Z")
         const isoString = date.toISOString();
         // Split at "T" and take the first part (the date)
         return isoString.split('T')[0]; // Returns "2025-05-27"
      },

      // Call get users api in Auth
      async getAuthUser(id, index) {
         await this.$axios_auth.get("/users/" + id)
            .then((response) => {
               if (response.data.user) {
                  let user = {
                     firstName: response.data.user.first_name,
                     lastName: response.data.user.last_name
                  }
                  this.leadNotes[index].user = user
               } else if (response.data.user == null && id != "") {
                  this.leadNotes[index].user = {
                     firstName: "Deleted",
                     lastName: "User"
                  }
               } else {
                  this.leadNotes[index].user = {
                     firstName: "System",
                     lastName: "Generated"
                  }
               }
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      async getVertexAuthUser(id, index) {
          //let vtxUsers = this.$store.state.auth.usersWithVertexRoles

           let user = Array.isArray(this.vtxUsers) ? this.vtxUsers.find(user => user && user.id === id) : null;

           console.log("user found:", user)
           console.log("id passed:", id)

           if (user) {
              this.leadNotes[index].user = {
                 firstName: user.first_name,
                 lastName: user.last_name
              }
           } else if (user == null && id != "") {
              this.leadNotes[index].user = {
                 firstName: "Deleted",
                 lastName: "User"
              }
           } else {
              this.leadNotes[index].user = {
                 firstName: "System",
                 lastName: "Generated"
              }
           }
      },

       getVertexUsers() {
         //console.log("getVertexUsers called:", this.$store.state.auth.usersWithVertexRoles)
         this.vtxUsers = this.$store.state.auth.usersWithVertexRoles || []
      },


      // loop through the notes and get user 
      getUser() {
         for (let i in this.leadNotes) {
            let userId = this.leadNotes[i].created_by
            this.getVertexAuthUser(userId, i)
         }
      },

      async createLeadNote(id) {
         let leadNote = {
            note_type: 'note',
            note_details: this.enquiryDetails,
            lead_id: id,
         }

         await this.$axios.post("/leads/" + id + "/notes", leadNote)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)

                  this.resetForm();

                  this.getLeadNotes(id)
               } else {
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })

      },

      async updateLeadNote(data) {

         let leadNote = {
            note_details: data.note_details,
         }

         let leadId = data.lead_id
         let noteId = data.id

         await this.$axios.put("/leads/" + leadId + "/notes/" + noteId, leadNote)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)

                  this.resetForm();

                  this.getLeadNotes(leadId)
               } else {
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })

      },

      onSearch() {
         this.debounceFn(this.lead.id)
      },

      toggleFilterForm() {
         if (this.filterByActivity == "none" && this.filterByUser == "none") {
            this.clearFilter()
         }
      },

      clearFilter() {
         this.filterBy = ""
         this.filterByActivity = "none"
         this.filterByUser = "none"
         this.filtering.field = ""
         this.filtering.value = ""
         this.debounceFn(this.lead.id)
      },

      setFilterOptions(filter_field) {
         switch (filter_field) {
            case "user": {
               this.filterValueOptions = [{
                  id: "none",
                  name: "All"
               }, {
                  id: "0",
                  name: "System Generated"
               }]

               this.$store.state.auth.usersWithVertexRoles.forEach((s) => {
                  this.filterValueOptions.push({
                     id: s.id,
                     name: s.first_name + " " + s.last_name,
                  })
               })
               return;
            }
            case "activity": {
               this.filterValueOptions = [{
                  id: "none",
                  name: "All"
               },
               { id: "auth_org_link", name: "Auth Organisation Link" },
               { id: "auth_sync", name: "Auth Organisation Sync" },
               { id: "cold_lead", name: "Cold Lead" },
               { id: "initial_note", name: "Initial Note" },
               { id: "initial_note_internal", name: "Initial Note - Internal" },
               { id: "initial_note_pentest", name: "Initial Note - Pentest" },
               { id: "initial_note_website", name: "Initial Note - Website" },
               { id: "initial_status", name: "Initial Status" },
               { id: "initial_status_internal", name: "Initial Status - Internal" },
               { id: "initial_status_pentest", name: "Initial Status - Pentest" },
               { id: "initial_status_website", name: "Initial Status - Website" },
               { id: "loss_reason", name: "Loss Reason" },
               { id: "New", name: "New" },
               { id: "note", name: "Note" },
               { id: "priority", name: "Priority" },
               { id: "proposal_revision", name: "Proposal Revision" },
               { id: "proposal_upload", name: "Proposal Upload" },
               { id: "contract_sent", name: "Contract Sent" },
               { id: "specific_status", name: "Priority Update" },
               { id: "status", name: "Status" }
               ]
               return;
            }
         }
      },
   },
};

</script>

<style scoped>
.add-note-textarea {
   height: 80px;
   /* width: 640px; */
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.activity-textarea {
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.status,
.priority,
.initial_status,
.initial_status_internal,
.initial_status_pentest,
.initial_status_website,
.auth_org_link,
.auth_sync {
   font-style: italic;
   font-size: 12px;
}

.note,
.initial_note,
.initial_note_internal,
.initial_note_pentest,
.initial_note_website,
.loss_reason {
   font-size: 13px;
}

.prevStatus {
   color: #F3994D;
}

.newStatus {
   color: #00A54F;
}

.high {
   color: #EB1C24;
}

.low {
   color: #00A54F;
}

.medium {
   color: #F3994D;
}

/* .auth_org_link_details{
   color: #00A0C1;
} */

.activity-item {
   width: auto;
   border-radius: 0px 5px 5px 5px;
   border: 1px solid #435666;
}
</style>